(function() {

  // Check if previous dismissal has expired FIRST
  var dismissedExpiry = localStorage.getItem('bb_popup_dismissed');
  if (dismissedExpiry && new Date().getTime() > parseInt(dismissedExpiry)) {
    localStorage.removeItem('bb_popup_dismissed');
  }

  // Now check if dismissed or subscribed
  var dismissed = localStorage.getItem('bb_popup_dismissed');
  var subscribed = localStorage.getItem('bb_popup_subscribed');

  if (subscribed || dismissed) return;

  // Create popup HTML
  var popup = document.createElement('div');
  popup.id = 'bb-popup';
  popup.innerHTML = `
    <div class="bb-popup__overlay" id="bb-popup-overlay"></div>
    <div class="bb-popup__box">
      <button class="bb-popup__close" id="bb-popup-close" aria-label="Close">✕</button>
      <div class="bb-popup__left">
        <span class="bb-popup__flowers">🌸</span>
        <p class="bb-popup__eyebrow">Welcome to Baby & Bloom</p>
        <h2 class="bb-popup__title">Get 10% off your first order</h2>
        <p class="bb-popup__sub">Subscribe to our newsletter and receive an exclusive 10% discount — plus early access to new arrivals and honest mama advice from Kaylie.</p>
        <div class="bb-popup__perks">
          <div class="bb-popup__perk"><span class="bb-popup__star">✦</span> 10% off sitewide instantly</div>
          <div class="bb-popup__perk"><span class="bb-popup__star">✦</span> Early access to new arrivals</div>
          <div class="bb-popup__perk"><span class="bb-popup__star">✦</span> Sale alerts before anyone else</div>
          <div class="bb-popup__perk"><span class="bb-popup__star">✦</span> Nurse-mama advice & blog posts</div>
        </div>
      </div>
      <div class="bb-popup__right">
        <div class="bb-popup__badge">👩‍⚕️ Nurse & Mama approved</div>
        <h3 class="bb-popup__card-title">Join the Bloom family 🌿</h3>
        <p class="bb-popup__card-sub">Enter your details below to claim your exclusive discount code.</p>
        <div class="bb-popup__success" id="bb-popup-success" style="display:none;">
          <p>🌸 Welcome to the Bloom family!</p>
          <p style="margin:8px 0 4px;font-size:12px;">Your exclusive discount code is:</p>
          <div class="bb-popup__code">WELCOME10</div>
          <p style="font-size:11px;margin-top:8px;">Use this code at checkout for <strong>10% off</strong> your entire order.</p>
        </div>
        <div id="bb-popup-form">
          <div class="bb-popup__field">
            <input class="bb-popup__input" type="text" id="bb-popup-name" placeholder="Your first name" autocomplete="given-name">
          </div>
          <div class="bb-popup__field">
            <input class="bb-popup__input" type="email" id="bb-popup-email" placeholder="Your email address" autocomplete="email" required>
          </div>
          <button class="bb-popup__btn" id="bb-popup-submit">Claim my 10% off 🌸</button>
          <p class="bb-popup__disclaimer">No spam, ever. Unsubscribe anytime.</p>
        </div>
        <button class="bb-popup__skip" id="bb-popup-skip">No thanks, I'll pay full price</button>
      </div>
    </div>
  `;

  // Add styles
  var style = document.createElement('style');
  style.innerHTML = `
    #bb-popup {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      box-sizing: border-box;
      opacity: 0;
      transition: opacity 0.4s ease;
      pointer-events: none;
    }
    #bb-popup.bb-popup--visible {
      opacity: 1;
      pointer-events: all;
    }
    .bb-popup__overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(47, 74, 58, 0.7);
      backdrop-filter: blur(4px);
      cursor: pointer;
    }
    .bb-popup__box {
      position: relative;
      background: #ffffff;
      border-radius: 24px;
      max-width: 820px;
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      overflow: hidden;
      box-shadow: 0 24px 80px rgba(0,0,0,0.2);
      transform: translateY(20px);
      transition: transform 0.4s ease;
      max-height: 90vh;
      overflow-y: auto;
    }
    #bb-popup.bb-popup--visible .bb-popup__box {
      transform: translateY(0);
    }
    .bb-popup__close {
      position: absolute;
      top: 16px;
      right: 16px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: rgba(255,255,255,0.9);
      border: 1px solid #e8e0db;
      cursor: pointer;
      font-size: 14px;
      color: #7A6B65;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      transition: all 0.2s ease;
    }
    .bb-popup__close:hover { background: #4A6B5A; color: #ffffff; border-color: #4A6B5A; }
    .bb-popup__left {
      background: linear-gradient(145deg, #2f4a3a, #4A6B5A);
      padding: 48px 36px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .bb-popup__flowers { font-size: 36px; margin-bottom: 12px; display: block; }
    .bb-popup__eyebrow { font-size: 10px; letter-spacing: 0.2em; text-transform: uppercase; color: #E8B4B8; font-family: Arial, sans-serif; margin-bottom: 10px; }
    .bb-popup__title { font-size: 28px; color: #ffffff; font-family: 'Cormorant Garamond', Georgia, serif; margin: 0 0 14px; line-height: 1.2; }
    .bb-popup__sub { font-size: 13px; color: rgba(255,255,255,0.75); font-family: Arial, sans-serif; line-height: 1.7; margin-bottom: 24px; }
    .bb-popup__perks { display: flex; flex-direction: column; gap: 8px; }
    .bb-popup__perk { font-size: 12px; color: rgba(255,255,255,0.85); font-family: Arial, sans-serif; display: flex; align-items: center; gap: 8px; }
    .bb-popup__star { color: #E8B4B8; font-size: 11px; flex-shrink: 0; }
    .bb-popup__right { padding: 48px 36px; display: flex; flex-direction: column; justify-content: center; background: #faf8f5; }
    .bb-popup__badge { display: inline-block; background: #e8f0ec; border: 1px solid #4A6B5A; border-radius: 20px; padding: 5px 14px; font-size: 11px; color: #4A6B5A; font-family: Arial, sans-serif; font-weight: 600; margin-bottom: 16px; width: fit-content; }
    .bb-popup__card-title { font-size: 20px; color: #4A6B5A; font-family: 'Cormorant Garamond', Georgia, serif; margin: 0 0 8px; }
    .bb-popup__card-sub { font-size: 12px; color: #7A6B65; font-family: Arial, sans-serif; line-height: 1.6; margin-bottom: 20px; }
    .bb-popup__field { margin-bottom: 10px; }
    .bb-popup__input { width: 100%; padding: 12px 16px; border: 1.5px solid #e8e0db; border-radius: 12px; font-size: 13px; color: #3A2E2B; font-family: Arial, sans-serif; background: #ffffff; outline: none; transition: border-color 0.2s ease; box-sizing: border-box; }
    .bb-popup__input:focus { border-color: #4A6B5A; }
    .bb-popup__input::placeholder { color: #b0a8a4; }
    .bb-popup__btn { width: 100%; padding: 14px; background: #C47C82; color: #ffffff; border: none; border-radius: 40px; font-size: 12px; letter-spacing: 0.1em; text-transform: uppercase; font-weight: 600; cursor: pointer; font-family: Arial, sans-serif; transition: background 0.2s ease; margin-bottom: 10px; }
    .bb-popup__btn:hover { background: #a85060; }
    .bb-popup__disclaimer { font-size: 10px; color: #b0a8a4; font-family: Arial, sans-serif; text-align: center; margin: 0 0 16px; }
    .bb-popup__skip { background: none; border: none; font-size: 11px; color: #b0a8a4; font-family: Arial, sans-serif; cursor: pointer; text-align: center; text-decoration: underline; text-underline-offset: 3px; padding: 0; transition: color 0.2s ease; }
    .bb-popup__skip:hover { color: #7A6B65; }
    .bb-popup__success { background: #e8f0ec; border: 1.5px solid #4A6B5A; border-radius: 12px; padding: 16px; font-size: 13px; color: #4A6B5A; font-family: Arial, sans-serif; text-align: center; margin-bottom: 16px; line-height: 1.6; }
    .bb-popup__code {
      background: #4A6B5A;
      color: #ffffff;
      padding: 12px 20px;
      border-radius: 10px;
      font-size: 22px;
      font-weight: 700;
      letter-spacing: 0.2em;
      margin: 10px auto;
      display: inline-block;
      cursor: pointer;
      font-family: Arial, sans-serif;
    }
    .bb-popup__code:hover { background: #2f4a3a; }
    @media screen and (max-width: 649px) {
      .bb-popup__box { grid-template-columns: 1fr; border-radius: 20px; max-height: 85vh; }
      .bb-popup__left { padding: 36px 28px 24px; }
      .bb-popup__right { padding: 24px 28px 36px; }
      .bb-popup__title { font-size: 22px; }
      .bb-popup__perks { display: none; }
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(popup);

// Show popup after 3 seconds
  setTimeout(function() {
    popup.classList.add('bb-popup--visible');
  }, 3000);

  function closePopup(wasDismissed) {
    popup.classList.remove('bb-popup--visible');
    setTimeout(function() {
      if (popup.parentNode) popup.remove();
    }, 400);
    if (wasDismissed) {
      var expiry = new Date().getTime() + (24 * 60 * 60 * 1000);
      localStorage.setItem('bb_popup_dismissed', expiry);
    }
  }

  document.getElementById('bb-popup-close').addEventListener('click', function() { closePopup(true); });
  document.getElementById('bb-popup-overlay').addEventListener('click', function() { closePopup(true); });
  document.getElementById('bb-popup-skip').addEventListener('click', function() { closePopup(true); });

  document.getElementById('bb-popup-submit').addEventListener('click', function() {
    var email = document.getElementById('bb-popup-email').value;
    var name = document.getElementById('bb-popup-name').value;

    if (!email || !email.includes('@')) {
      document.getElementById('bb-popup-email').style.borderColor = '#C47C82';
      document.getElementById('bb-popup-email').focus();
      return;
    }

    // Submit to Shopify newsletter
    var formData = new FormData();
    formData.append('contact[email]', email);
    formData.append('contact[first_name]', name);
    formData.append('contact[accepts_marketing]', true);
    formData.append('form_type', 'customer');
    formData.append('utf8', '✓');

    fetch('/contact', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).finally(function() {
      document.getElementById('bb-popup-form').style.display = 'none';
      document.getElementById('bb-popup-success').style.display = 'block';
      localStorage.setItem('bb_popup_subscribed', 'true');
    });
  });

  // Copy code on click
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('bb-popup__code')) {
      navigator.clipboard.writeText(e.target.innerText).then(function() {
        e.target.innerText = 'COPIED! ✓';
        setTimeout(function() {
          e.target.innerText = 'WELCOME10';
        }, 2000);
      });
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closePopup(true);
  });

})();